import axios, { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { config } from "../contexts/UrlContext";
import { getRequest, postRequest } from "../services/axiosService";

export interface IAppearance {
    logo: string,
    background: string,
    backgroundColour: string,
    fontColour: string,
    titleColour: string,
    title: string,
    subTitle: string
}

export const getAppearanceData = async (auth: any) => {

    try {
        let response: AxiosResponse = await getRequest(auth, `/Admin/GetAppearance`);

        return response.data;
    } catch(error) {
        console.log(error);
        toast.error("Error retrieving appearance");
        return null;
    }
}

export const UpdateAppearance = async (appearanceSettings: any, auth: any) => {
    try {
        let response: AxiosResponse = await postRequest(auth, `/Admin/SaveAppearanceSettings`, appearanceSettings);

        toast.success("Settings saved");
    } catch(error) {
        console.log(error);
        toast.error("Error updating appearance");
    }
 }

function useAppearance() {

    const [appearance, setAppearance] = useState<IAppearance>();

    useEffect(() => {
        async function getData() {
           await getAppearanceSettings();
        }
        getData();
    }, []);

    const getAppearanceSettings = async () => {
        axios.get(`${config.baseUrl}/api/Admin/GetAppearance`)
            .then((response: any) => {
            let data = response.data;
            setAppearance(data);
        })
            .catch((error) => {
            console.log(error);
            toast.error("Error retrieving appearance");
        })
    }

    const updateAppearance = (appearanceSettings: IAppearance) => {
        axios.post(`${config.baseUrl}/api/Admin/SaveAppearanceSettings`, appearanceSettings)
            .then((response: any) => {
			toast.success("Settings saved");
            setAppearance(response.data);
            }).catch((error) => {
			console.log(error);
			toast.error(`Unable to save Settings`);
		})
    }

    return  {
        updateAppearance
    };
}

export default useAppearance;